export const notificationTypes = {
  CONTRADICTORY_FACTS: 'CONTRADICTORY_FACTS',
  PUBLISH_DELAY: 'PUBLISH_DELAY',
  LOW_UPDATE_FREQUENCY: 'LOW_UPDATE_FREQUENCY',
  ROOMS_WITHOUT_IMAGES: 'ROOMS_WITHOUT_IMAGES',
  LOW_RESOLUTION_IMAGES: 'LOW_RESOLUTION_IMAGES',
  GENERIC: 'GENERIC',
}

export const notificationSeverity = {
  ALERT: 'alert',     // red dot (--color-primary-1)
  WARNING: 'warning', // orange dot (#ff9500)
  INFO: 'info',       // grey dot (--color-grayscale-3)
}

export const notificationTypeConfig = {
  [notificationTypes.CONTRADICTORY_FACTS]: {
    severity: notificationSeverity.ALERT,
  },
  [notificationTypes.PUBLISH_DELAY]: {
    severity: notificationSeverity.WARNING,
  },
  [notificationTypes.LOW_UPDATE_FREQUENCY]: {
    severity: notificationSeverity.WARNING,
  },
  [notificationTypes.ROOMS_WITHOUT_IMAGES]: {
    severity: notificationSeverity.WARNING,
  },
  [notificationTypes.LOW_RESOLUTION_IMAGES]: {
    severity: notificationSeverity.WARNING,
  },
}
